module.exports = __webpack_public_path__ + "img/user-group_ms.d2fdf3ef.png";